module.exports = __webpack_public_path__ + "media/images/homes/virtual_terminal-b04359baa85084f7dcf2abf2b06bd52d.svg";